import { Slider, SxProps } from '@mui/material';
import React, { useMemo } from 'react';
import { FieldWrapper } from './FieldWrapper';
import { FieldProps, StepSliderFieldSchema } from '../types/Form';

const sliderStyle: SxProps = {
  color: 'customGrey.dark',
  height: '5px',
  '& .MuiSlider-thumb': {
    backgroundColor: 'white',
    height: '30px',
    width: '30px',
    boxShadow: 'none',
    border: '4px solid',
    borderColor: 'primary.main'
  },
  '& .MuiSlider-rail': {
    color: 'primary.light',
    opacity: 1
  },
  '& .MuiSlider-track': {
    color: 'primary.main',
    height: '5px'
  },
  '& .MuiSlider-mark': {
    backgroundColor: 'primary.main',
    height: '7px',
    width: '6px',
    opacity: 1,
    border: 'none',
    borderRadius: '0'
  },
  '& .MuiSlider-markActive': {
    backgroundColor: 'white',
    border: 'none'
  },
  '& .MuiSlider-markLabel': {
    color: 'text.primary',
    fontSize: '12px',
    mt: '-50px'
  },
  '& .MuiSlider-markLabel[data-index="0"]': {
    transform: 'translateX(-10%)'
  },
  '&.Mui-disabled': {
    opacity: 0.3
  }
};

export type StepSliderFieldProps = FieldProps<StepSliderFieldSchema>;
export const StepSlider: React.FC<StepSliderFieldProps> = ({
  name,
  errorMessage,
  value,
  field,
  onChange
}) => {
  const { step = 1, marks, containerSx, disabled } = field;

  const { max, min } = useMemo(() => {
    const markValues = marks.map((mark) => mark.value);

    const min = Math.min(...markValues);
    const max = Math.max(...markValues);

    return {
      min,
      max
    };
  }, [JSON.stringify(marks)]);

  return (
    <FieldWrapper
      errorMessage={errorMessage}
      sx={{
        mt: 3,
        ...containerSx
      }}
    >
      <Slider
        name={name}
        value={value}
        min={min}
        step={step}
        max={max}
        marks={marks}
        disabled={disabled}
        onChange={(_, newValue) =>
          typeof newValue === 'number' ? onChange(newValue) : undefined
        }
        sx={{
          ...sliderStyle,
          [`& .MuiSlider-markLabel[data-index="${marks.length - 1}"]`]: {
            transform: 'translateX(-90%)'
          }
        }}
      />
    </FieldWrapper>
  );
};
